/*** 検索条件からURLSearchParamsのクエリ文字列を生成する */
export const generateSearchQuery = <T extends Record<string, unknown>>({
  lastSearched,
  defaultParams,
  defaultPath,
}: {
  lastSearched: T | null | undefined;
  defaultParams?: Partial<Record<keyof T, unknown>>;
  defaultPath: string;
}): string => {
  if (!lastSearched) {
    return defaultPath;
  }

  const searchParams = {
    ...lastSearched,
    defaultParams,
  };
  // 存在しないものは弾く
  const filteredSearchParams = Object.fromEntries(
    Object.entries(searchParams).flatMap(([key, value]) =>
      value !== null && value !== undefined ? [[key, String(value)]] : [],
    ),
  );
  const queryString = new URLSearchParams(filteredSearchParams).toString();
  return [defaultPath, queryString].filter(Boolean).join('?');
};
